import {createSlice} from './createSlice';

const getInitialState = () => {
    return {
        apiUrl: undefined,
        apiKey: undefined,
        authToken: undefined,
        authHolderToken: undefined,
        assets: [],
    };
};

const slice = createSlice(getInitialState());

export const getState = slice.getState;
export const setState = (data) => {
    slice.setState(data);
};

export const resetUamState = () => {
    setState(getInitialState());
};

export const setUamData = ({apiUrl, apiKey, authToken, isHolder}) => {
    setState({
        apiUrl,
        apiKey,
    });

    if (isHolder) {
        setState({authHolderToken: authToken});
    } else {
        setState({authToken});
    }
};

export const setUamAsset = (assetId, isHolder) => {
    setState({assets: [...getState().assets, {assetId, isHolder}]});
};

export const clearUamAssets = () => {
    setState({assets: []});
};
